import realizaSelectors from './realiza';

export default realizaSelectors('pet', 'PET.LANDING');
